import { TemplateConfig } from './template-config.interface';
import { CreativityType } from '../../types/banner';
import { DISNEY_TEMPLATES } from './DISNEY';
import { RESUMIDO_TEMPLATES } from './RESUMIDO';
import { TEST_TEMPLATES } from './TEST';
import { GPOVALLAS_TEMPLATES } from './GPOVALLAS';
import { MACRO_TEMPLATES } from './MACRO';

// Registry completo
export const TEMPLATE_REGISTRY: TemplateConfig[] = [
  ...DISNEY_TEMPLATES,
  ...RESUMIDO_TEMPLATES,
  ...TEST_TEMPLATES,
  ...GPOVALLAS_TEMPLATES,
  ...MACRO_TEMPLATES
];

const VALID_CREATIVITY_NAMES = TEMPLATE_REGISTRY.map(t => t.id);

export const getCreativityOptions = (clientId: string): TemplateConfig[] => {
  return TEMPLATE_REGISTRY.filter(t => t.clientId === clientId);
};

export const getCreativityForms = (clientId: string) => {
  const templates = getCreativityOptions(clientId);

  return templates.reduce(
    (acc, template) => {
      acc[template.id] = {
        title: template.title,
        fields: template.formFields,
        templateFamily: template.templateFamily
      };
      return acc;
    },
    {} as Record<string, { title: string; fields: any[]; templateFamily?: string }>
  );
};

export const getTemplateByBannerType = (bannerType: string): TemplateConfig | undefined => {
  // 1. Búsqueda exacta
  let template = TEMPLATE_REGISTRY.find(t => t.id === bannerType);
  if (template) return template;

  // 2. Buscar la coincidencia más específica (id más largo que coincida)
  const matches = TEMPLATE_REGISTRY.filter(t => bannerType.startsWith(t.id) || bannerType.includes(t.id));

  if (matches.length === 0) return undefined;

  // Retornar el template con el id más largo (más específico)
  return matches.reduce((longest, current) => (current.id.length > longest.id.length ? current : longest));
};

export const isValidCreativityType = (type: string): type is CreativityType => {
  return VALID_CREATIVITY_NAMES.includes(type);
};
